import { Col, Form, Input, Row } from 'antd';
import React, { useEffect } from 'react';
interface Props {
  listDetail: any;
}

const { TextArea } = Input;

const CommentDelivery = ({ listDetail }: Props) => {
  const [form] = Form.useForm();
  const mapProductComment: any = listDetail;

  useEffect(() => {
    form.setFieldsValue({
      packagingMethod: mapProductComment.packagingMethod,
      dangerous: mapProductComment.dangerous,
      shippingMethod: mapProductComment.shippingMethod,
      sellerComment: mapProductComment?.sellerComment
    });
  }, [listDetail]);

  return (
    <div>
      <div className="cmtDelivery" style={{ padding: '20px', borderBottom: 0, paddingBottom: 0 }}>
        {' '}
        <Form form={form} layout="vertical">
          <Row className="rowDeliver">
            <Col span={4}>
              <Form.Item label="Packing Method" name="packagingMethod">
                <Input className="border-input" disabled />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label="Dangerous Goods" name="dangerous">
                <Input className="border-input" disabled />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Shipping Method" name="shippingMethod">
                <Input className="border-input" disabled />
              </Form.Item>
            </Col>
          </Row>{' '}
          <Col span={24}>
            <div className="commentDelivery">
              <Form.Item name="sellerComment">
                <p>Comment from Seller</p>
                <p className="ant-input">{listDetail?.sellerComment}</p>
                {/* <Input.TextArea
                  defaultValue={jjj}
                  style={{ resize: 'none' }}
                  cols={4}
                  disabled
                /> */}
              </Form.Item>
            </div>{' '}
          </Col>
        </Form>
      </div>
    </div>
  );
};

export default CommentDelivery;
